import React from "react";

const RadioGroup = ({
                        id,
                        name,
                        value,
                        checked,
                        onClick,
                        disabled,
                        title,
                        customRadioSpanClass,
                        customRadioClass,
                        customClass,
                    }) => {

    return (
        <span className={customRadioSpanClass}>
      <input
          id={id}
          type="radio"
          name={name}
          className={`default-font pointer ${customRadioClass || ""}`}
          value={value}
          defaultChecked={checked}
          onClick={onClick}
          disabled={disabled}
      />
      <label
          htmlFor={id}
          className={`pointer ${customClass || ""}`}
      >
        {title}
      </label>
    </span>
    );
};

export default RadioGroup;
